// extracted by mini-css-extract-plugin
export default {"wrapper":"loading_page_wrapper__1JiJI"};